"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview32_exports = {};
__export(GeodesPreview32_exports, {
  default: () => GeodesPreview32_default
});
module.exports = __toCommonJS(GeodesPreview32_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.2822 1.90918C11.1715 1.87598 11.0775 1.86491 11 1.87598C10.9225 1.87598 10.8285 1.90918 10.7178 1.97559L4.55859 5.52832C4.44792 5.59473 4.37044 5.66667 4.32617 5.74414C4.29297 5.82161 4.27637 5.91569 4.27637 6.02637V13.0986C4.27637 13.2093 4.30404 13.3145 4.35938 13.4141C4.41471 13.5026 4.48112 13.5635 4.55859 13.5967L10.7178 17.1494C10.8285 17.1826 10.9336 17.1992 11.0332 17.1992C11.1328 17.1992 11.2158 17.1826 11.2822 17.1494L17.4414 13.5967C17.5521 13.5303 17.624 13.4583 17.6572 13.3809C17.7015 13.3034 17.7236 13.2093 17.7236 13.0986V5.94336C17.7236 5.84375 17.696 5.74967 17.6406 5.66113C17.5853 5.56152 17.5189 5.49512 17.4414 5.46191L11.2822 1.90918ZM10.2861 1.27832C10.5075 1.16764 10.7344 1.1123 10.9668 1.1123C11.1992 1.1123 11.4206 1.16764 11.6309 1.27832L17.8066 4.81445C18.0169 4.92513 18.1829 5.09115 18.3047 5.3125C18.4375 5.53385 18.5039 5.77181 18.5039 6.02637V13.0986C18.5039 13.3532 18.4375 13.5856 18.3047 13.7959C18.1829 13.9951 18.0169 14.1667 17.8066 14.3105L11.6309 17.8467C11.4206 17.9574 11.1992 18.0127 10.9668 18.0127C10.7344 18.0127 10.5075 17.9574 10.2861 17.8467L4.12695 14.3105C3.91667 14.1999 3.74512 14.0339 3.6123 13.8125C3.47949 13.5911 3.41309 13.3532 3.41309 13.0986V6.02637C3.41309 5.77181 3.47949 5.54492 3.6123 5.3457C3.74512 5.13542 3.91667 4.95833 4.12695 4.81445L10.2861 1.27832ZM14.6191 11.9033C14.6523 11.9365 14.68 11.9863 14.7021 12.0527C14.7354 12.1191 14.752 12.1855 14.752 12.252C14.752 12.3294 14.7354 12.4014 14.7021 12.4678C14.68 12.5231 14.6523 12.5674 14.6191 12.6006C14.5749 12.6449 14.5195 12.6836 14.4531 12.7168C14.3978 12.7389 14.3314 12.75 14.2539 12.75H7.38086C7.31445 12.75 7.24805 12.7389 7.18164 12.7168C7.11523 12.6836 7.06543 12.6449 7.03223 12.6006C6.99902 12.5342 6.96582 12.4788 6.93262 12.4346C6.91048 12.3903 6.89941 12.3294 6.89941 12.252C6.89941 12.1855 6.91048 12.1191 6.93262 12.0527C6.96582 11.9863 6.99902 11.9365 7.03223 11.9033C7.06543 11.8701 7.11523 11.8369 7.18164 11.8037C7.24805 11.7705 7.31445 11.7539 7.38086 11.7539H14.2539C14.3314 11.7539 14.3978 11.7705 14.4531 11.8037C14.5195 11.8369 14.5749 11.8701 14.6191 11.9033ZM12.627 9.13086C12.6602 9.17513 12.6934 9.23047 12.7266 9.29688C12.7598 9.35221 12.7764 9.41862 12.7764 9.49609C12.7764 9.5625 12.7598 9.62891 12.7266 9.69531C12.6934 9.76172 12.6602 9.81152 12.627 9.84473C12.5938 9.87793 12.5439 9.91113 12.4775 9.94434C12.4111 9.97754 12.3447 9.99414 12.2783 9.99414H7.38086C7.31445 9.99414 7.24805 9.97754 7.18164 9.94434C7.11523 9.91113 7.06543 9.87793 7.03223 9.84473C6.99902 9.81152 6.96582 9.76172 6.93262 9.69531C6.91048 9.62891 6.89941 9.5625 6.89941 9.49609C6.89941 9.41862 6.91048 9.35221 6.93262 9.29688C6.96582 9.23047 6.99902 9.17513 7.03223 9.13086C7.06543 9.09766 7.11523 9.06999 7.18164 9.04785C7.24805 9.01465 7.31445 8.99805 7.38086 8.99805H12.2783C12.3447 8.99805 12.4111 9.01465 12.4775 9.04785C12.5439 9.06999 12.5938 9.09766 12.627 9.13086ZM14.9678 6.52441C15.001 6.59082 15.0286 6.64616 15.0508 6.69043C15.084 6.7347 15.1006 6.79557 15.1006 6.87305C15.1006 6.93945 15.084 7.00586 15.0508 7.07227C15.0286 7.13867 15.001 7.18848 14.9678 7.22168C14.9346 7.25488 14.8848 7.28809 14.8184 7.32129C14.752 7.35449 14.6855 7.37109 14.6191 7.37109H7.38086C7.31445 7.37109 7.24805 7.35449 7.18164 7.32129C7.11523 7.28809 7.06543 7.25488 7.03223 7.22168C6.99902 7.18848 6.96582 7.13867 6.93262 7.07227C6.91048 7.00586 6.89941 6.93945 6.89941 6.87305C6.89941 6.79557 6.91048 6.7347 6.93262 6.69043C6.96582 6.64616 6.99902 6.59082 7.03223 6.52441C7.06543 6.48014 7.11523 6.44694 7.18164 6.4248C7.24805 6.3916 7.31445 6.375 7.38086 6.375H14.6191C14.6855 6.375 14.752 6.3916 14.8184 6.4248C14.8848 6.44694 14.9346 6.48014 14.9678 6.52441Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview32 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview32_default = SvgGeodesPreview32;
